export default {
  GET_THE_APP: 'Get the App',
  MAKE_FLOCK_BETTER_APPS: 'Make Flock even better with apps',
  groupPurpose_blank_value: "Set your channel's purpose here",
  messageArea_chatTab_text_historyButton:
    'This is the beginning of your chat with {name}',
  me_tab_user_status:
    'Save quick messages, files or links to read later. Track personal to-dos or create notes, without a worry!',
  me_tab_your_space: 'Your personal space',
  flock_support: 'Flock Support',
  flock_support_description:
    'Leave a message to directly chat with our support agents',
  group_chat_header_add_todo: 'Add a to-do',
  group_chat_header_set_reminder: 'Set a reminder',
  group_chat_header_connect_app: 'Connect an app',
  visible_to_me_text: 'Only you can see this',
  me_text: 'Me',
  history_fetch_error: 'Something went wrong while loading messages.',
  retry: 'Retry',
  pay_wall_user:
    'There are more messages here, but they exceed the limit of your free plan. Request your admin to upgrade your team to unlock all past messages',
  pay_wall_admin:
    'There are more messages here, but they exceed the limit of your free plan. Upgrade your team to unlock all past messages',
};
